import { ENEMIES } from '../../data/enemies';
import { SIM_HZ } from '../../data/tuning';

const EN01 = ENEMIES['EN-01'];

export interface GallinazoState {
  x: number;
  y: number;
  /** Altitude it was placed at; the sine oscillates around it. */
  readonly y0: number;
}

/**
 * EN-01 Gallinazo (GDD §8.2): flies straight left at the scroll speed plus 1 u/s (in world coordinates
 * the world already scrolls, so it only moves 1 u/s) with a vertical sine of 0.5 u at 1 Hz. The phase
 * starts on the tick it becomes active. Pure and deterministic: no RNG.
 */
export function stepGallinazo(enemy: GallinazoState, ticksSinceActive: number): GallinazoState {
  const t = ticksSinceActive / SIM_HZ;
  return {
    x: enemy.x - EN01.relativeSpeed / SIM_HZ,
    y: enemy.y0 + EN01.amplitude * Math.sin(2 * Math.PI * EN01.frequencyHz * t),
    y0: enemy.y0,
  };
}
